/**
 * Number of seconds before expiry to refresh the token.
 *
 * @type {number}
 */
export const AUTH_REFRESH_LEEWAY = 60 * 5;

export const ZITADEL_IDP_AUTH_INTENT_ID_PARAM = "id";
export const ZITADEL_IDP_AUTH_INTENT_TOKEN_URL_PARAM = "token";
export const ZITADEL_IDP_AUTH_IS_APP_REDIRECT_DISABLED_PARAM = "no-redirect";
export const ZITADEL_IDP_AUTH_BACK_URL_PARAM = "back-url";
export const ZITADEL_IDP_AUTH_SCHOOL_UNIQUE_KEY_PARAM = "school";

export const FAILED_AUTHENTICATION_PARAM = "failed-authentication";

